// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.20-13220(a394b6e5dc)-C15/09/2026-07:01:33-B15/09/2026-07:07:43' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.20-13220(a394b6e5dc)-C15/09/2026-07:01:33-B15/09/2026-07:07:43",
  branch: "production",
  latestTag: "8.0.20",
  revCount: "13220",
  shortHash: "a394b6e5dc",
  longHash: "a394b6e5dcfd20e80ad516cbc2e1d8866d1ed6cc",
  dateCommit: "15/09/2026-07:01:33",
  dateBuild: "15/09/2026-07:07:43",
  buildType: "Ansible",
  } ;
